import { Component, inject, model, signal } from '@angular/core';
import { Dialog } from 'primeng/dialog';

import { AuthRepository } from '../../data/repositories/auth.repository';
import { AuthRepositoryContract } from '../../data/repositories/auth.repository.contract';
import { LogoutUseCase } from '../../data/use-cases';

/**
 * "Log out?" confirmation (Figma 55238:53016). Drop it anywhere a sign-out
 * can start and flip `visible`; it runs the sign-out itself.
 *
 * Note the design's button order: the destructive action is the quiet
 * ghost button and Cancel is the filled red one — reproduced as drawn.
 */
@Component({
  selector: 'app-logout-dialog',
  imports: [Dialog],
  templateUrl: './logout-dialog.component.html',
  styleUrl: './logout-dialog.component.css',
  providers: [
    LogoutUseCase,
    {
      provide: AuthRepositoryContract,
      useClass: AuthRepository
    }
  ],
})
export class LogoutDialogComponent {
  private readonly logout = inject(LogoutUseCase);

  /** Two-way: `[(visible)]` from the host, or `.set(true)` through a ref. */
  readonly visible = model(false);
  /** True while the API is being told; the dialog cannot be dismissed then. */
  readonly busy = signal(false);

  open(): void {
    this.visible.set(true);
  }

  cancel(): void {
    if (!this.busy()) {
      this.visible.set(false);
    }
  }

  confirm(): void {
    if (this.busy()) {
      return;
    }
    this.busy.set(true);
    // Never errors (see LogoutUseCase); the navigation away happens inside it.
    this.logout.execute().subscribe(() => {
      this.busy.set(false);
      this.visible.set(false);
    });
  }
}
